import _createForOfIteratorHelper from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/**
 * check simply if current environment is browser or not
 * @returns boolean
 */
export function isInBrowser() {
  return typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
}
/**
 *
 * @param {Function} check funcion to check if adapter is installed. return true if
 * @returns
 */

export function checkAdapterState(check) {
  if (!isInBrowser()) return;
  var disposers = [];

  function dispose() {
    var _iterator = _createForOfIteratorHelper(disposers),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _dispose = _step.value;

        _dispose();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  function checkAndDispose() {
    if (check()) {
      dispose();
    }
  }

  var interval = setInterval(checkAndDispose, 500);
  disposers.push(function () {
    return clearInterval(interval);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndDispose, {
      once: true
    });
    disposers.push(function () {
      return document.removeEventListener('DOMContentLoaded', checkAndDispose);
    });
  }

  if (document.readyState !== 'complete') {
    window.addEventListener('load', checkAndDispose, {
      once: true
    });
    disposers.push(function () {
      return window.removeEventListener('load', checkAndDispose);
    });
  }

  checkAndDispose(); // stop all task after 1min

  setTimeout(dispose, 60 * 1000);
}
/**
 * Simplily detect mobile device
 */

export function isInMobileBrowser() {
  return typeof navigator !== 'undefined' && navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i);
}